// --------------------
// Route matcher
// --------------------
export function matchRoute(routePath: string, currentPath: string) {
  if (!routePath || !currentPath) return false;

  const routeParts = routePath.split('/').filter(Boolean);
  const pathParts = currentPath.split('/').filter(Boolean);

  // MUST match depth exactly
  if (routeParts.length !== pathParts.length) return false;

  return routeParts.every((part, index) => {
    if (part.startsWith(':')) return true;
    return part === pathParts[index];
  });
}

// --------------------
// Replace params in path
// --------------------
export function resolvePath(
  path: string,
  params: Record<string, string>
) {
  return path.replace(/:([^/]+)/g, (_, key) => params[key] ?? '');
}

// --------------------
// Flatten navigation tree
// --------------------
export function flattenNav(nav: any[], parentChain: any[] = []) {
  let result: any[] = [];

  nav.forEach(item => {
    const currentChain = [...parentChain, item];
    result.push(currentChain);

    if (item.items?.length) {
      result = result.concat(flattenNav(item.items, currentChain));
    }
  });

  return result;
}

// --------------------
// Breadcrumb generator
// --------------------
export function getBreadcrumbTrail(
  currentPath: string,
  navigation: any[],
  params: Record<string, string> = {}
) {
  const flatNav = flattenNav(navigation);

  // Find BEST (deepest) match
  const matched = flatNav
    .filter(chain =>
      matchRoute(chain[chain.length - 1].path, currentPath)
    )
    .sort(
      (a, b) =>
        b[b.length - 1].path.split('/').length -
        a[a.length - 1].path.split('/').length
    )[0];

  if (!matched) return [];

  return matched
    .filter((item: { path: any; label: any; }) => item?.path && item?.label)
    .map((item: { label: any; path: string; }) => {
      let label = item.label;

      // Replace dynamic label if exists
      if (item.path.includes(':')) {
        item.path.split('/').forEach((segment: string) => {
          if (segment.startsWith(':')) {
            const key = segment.replace(':', '');
            label = params[key] ?? label;
          }
        });
      }

      return {
        label,
        href: resolvePath(item.path, params),
      };
    });
}
